import React from 'react';
import './DestinationDetail.css';
import firebase from 'firebase/app';
import 'firebase/database';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import t1 from '../images/t1.png';
import t2 from '../images/t2.png';
import t3 from '../images/t3.png';
import t4 from '../images/t4.png';
import t5 from '../images/t5.jpg';
import Preloader from "./Preloader";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
    slidesToSlide: 1,
  },
};

class DestinationDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      data1: [],
      data2: [],
      data3: [],
      isToggleOn: false,
      loading: true,
    };
  }

  componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get("id");

    var config = {
      apiKey: "AIzaSyAUH1c3vQdx2i0opPtxgp-Ls_6n9HjnrkM",
      authDomain: "database-garutmenawan.firebaseapp.com",
      databaseURL: "https://database-garutmenawan.firebaseio.com",
      projectId: "database-garutmenawan",
      storageBucket: "database-garutmenawan.appspot.com",
      messagingSenderId: "860698778278",
      appId: "1:860698778278:web:3f78408de6efafba977267",
      measurementId: "G-LVK2C6MMGJ",
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }

    firebase
      .database()
      .ref()
      .child(id)
      .on("value", (snap) => {
        let data = snap.val();
        data.component1.shift();
        data.component3.shift();
        this.setState({
          data: data,
          data1: data.component1,
          data2: data.component2,
          data3: data.component3,
        });
        setTimeout(
          () =>
            this.setState({
              loading: false,
            }),
          500
        );
      });

    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <div className="destinationDetail">
          <div className="jumbotron-fluid">
            <div id="demo" className="carousel slide" data-ride="carousel">
              <ul className="carousel-indicators">
                <li data-target="#demo" data-slide-to="0" className="active"></li>
                <li data-target="#demo" data-slide-to="1"></li>
                <li data-target="#demo" data-slide-to="2"></li>
              </ul>
              <div className="carousel-inner">
                {this.state.data1 !== null
                  ? this.state.data1.map((comp1, index) => (
                      <div key={index} className={"carousel-item" + (index === 0 ? " active" : " ")}>
                        <img
                          src={"https://garutmenawan.faisalhakim.com/zimages/" + comp1.image + ".jpg"}
                          className="img-fluid img"
                          alt=""
                        />
                        <div className="carousel-caption">
                          <h1>{comp1.name}</h1>
                          <p>- Foto : {comp1.ref} -</p>
                        </div>
                      </div>
                    ))
                  : ""}
              </div>
              <a className="carousel-control-prev" href="#demo" data-slide="prev">
                <span className="carousel-control-prev-icon"></span>
              </a>
              <a className="carousel-control-next" href="#demo" data-slide="next">
                <span className="carousel-control-next-icon"></span>
              </a>
            </div>
            <div className="container-fluid infoDetail">
              <h1 className="newTitle">
                <span>In</span>formasi
              </h1>
              <div className="row">
                <div className="col-lg-5 mx-auto my-auto">
                  <span className="font-weight-bold toggleSpan">Peta &emsp;</span>
                  {this.state.data2.iframe2 != null ? (
                    <>
                      <Toggle
                        id="cheese-status"
                        icons={false}
                        defaultChecked={this.state.isToggleOn}
                        onChange={(e) => this.setState({ isToggleOn: e.target.checked })}
                      />
                      <span className="font-weight-bold toggleSpan">&emsp; Panorama</span>
                    </>
                  ) : (
                    <></>
                  )}
                  <iframe
                    src={this.state.isToggleOn ? this.state.data2.iframe2 : this.state.data2.iframe}
                    className="shadow rounded border img-fluid"
                    frameBorder="0"
                    style={{ border: 0, padding: 10 + "px" }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"
                    title="Maps"
                  ></iframe>
                </div>
                <div className="col-lg-6 mx-auto my-auto text-justify">
                  <h5>Lokasi</h5>
                  <p>{this.state.data2.lokasi}</p>
                  <h5>Tiket masuk</h5>
                  <p>{this.state.data2.tiket}</p>
                  <h5>Transportasi</h5>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: this.state.data2.transportasi,
                    }}
                  ></p>
                  <h5>Fasilitas</h5>
                  <p>{this.state.data2.fasilitas}</p>
                </div>
              </div>
            </div>
            <div className="container-fluid akomodasiDetail">
              <h1 className="newTitle">
                <span>Ak</span>omodasi
              </h1>
              <Carousel
                swipeable={true}
                draggable={false}
                showDots={false}
                renderDotsOutside={true}
                responsive={responsive}
                ssr={true}
                infinite={true}
                autoPlay={false}
                autoPlaySpeed={5000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={this.props.deviceType}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
              >
                {this.state.data3 !== null
                  ? this.state.data3.map((comp3, index) => (
                      <div key={index} className="container">
                        <a href={comp3.href}>
                          <img
                            src={"https://garutmenawan.faisalhakim.com/zimages/" + comp3.img + ".jpg"}
                            className="img-fluid image rounded shadow"
                            alt=""
                          />
                          <div className="middle">
                            <div className="text" dangerouslySetInnerHTML={{ __html: comp3.text }}></div>
                          </div>
                        </a>
                      </div>
                    ))
                  : ""}
              </Carousel>
            </div>
            <div className="container-fluid travelDetail">
              <h1 className="newTitle">
                <span>Tr</span>avel
              </h1>
              <Carousel
                swipeable={true}
                draggable={false}
                showDots={false}
                renderDotsOutside={true}
                responsive={responsive}
                ssr={true}
                infinite={true}
                autoPlay={false}
                autoPlaySpeed={10000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={this.props.deviceType}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
              >
                <div>
                  <a href="https://jelajahgarut.com/">
                    <img src={t1} className="img-fluid" alt=" " />
                    <h5>Jelajah Garut</h5>
                  </a>
                </div>
                <div>
                  <a href="https://digarut.com/">
                    <img src={t2} className="img-fluid" alt=" " />
                    <h5>Di Garut</h5>
                  </a>
                </div>
                <div>
                  <a href="https://www.doyanjalan.com/">
                    <img src={t3} className="img-fluid" alt=" " />
                    <h5>Doyan Jalan</h5>
                  </a>
                </div>
                <div>
                  <a href="https://pesonaindo.com/">
                    <img src={t4} className="img-fluid" alt=" " />
                    <h5>Pesona Indo</h5>
                  </a>
                </div>
                <div>
                  <a href="https://sanjayatour.com/">
                    <img src={t5} className="img-fluid" alt=" " />
                    <h5>Sanjaya Tour</h5>
                  </a>
                </div>
              </Carousel>
            </div>
          </div>
          <p className="copyright text-center">Copyright © 2020 WeSpace | All Right Reversed</p>
        </div>
        <Preloader loading={this.state.loading} />
      </>
    );
  }
}

export default DestinationDetail;
